import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import pipeline from './modules/pipelines/pipeline';
import pipelineV2 from './modules/pipelines/pipelineV2';
import customer from './modules/customer';
import payment from './modules/payment';
import paymentTypes from './modules/payments/payment-types';
import preorder from './modules/preorder';
import shoppingCart from './modules/shopping-cart';
import antifraud from './modules/antifraud';
import mpi from './modules/mpi';
import cart from './modules/cart';
import discount from './modules/discount';
import orderStatus from './modules/orderStatus';
// Payment modules
import recurrentPayment from './modules/payments/recurrentPayment';
import cardPayment from './modules/payments/card-payment';
import boletoPayment from './modules/payments/boletoPayment';
import pixPayment from './modules/payments/pixPayment';
import qrCodePayment from './modules/payments/qrCodePayment';
import clickToPayPayment from './modules/payments/clickToPayPayment';
import googlePayPayment from './modules/payments/googlePayPayment';
import applePayPayment from './modules/payments/applePayPayment';
import walletTypes from './modules/payments/wallet-types';
import pixOpenFinancePayment from './modules/payments/pixOpenFinancePayment';
// Shipping Address
import shippingAddress from './modules/shipping/shippingAddress';
import shippingType from './modules/shipping/shippingType';
// Billing
import billingAddress from './modules/billingAddress';
//Wallet
import merchantLayout from './modules/merchantLayout';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: false,
    modules: {
        pipeline,
        pipelineV2,
        customer,
        payment,
        paymentTypes,
        preorder,
        shoppingCart,
        antifraud,
        recurrentPayment,
        mpi,
        cardPayment,
        shippingAddress,
        shippingType,
        billingAddress,
        cart,
        boletoPayment,
        pixPayment,
        qrCodePayment,
        clickToPayPayment,
        googlePayPayment,
        merchantLayout,
        discount,
        orderStatus,
        walletTypes,
        applePayPayment,
        pixOpenFinancePayment,
    }
});
